import React from 'react';
export function HeroSection() {
  const scrollToCompra = () => {
    const el = document.getElementById('compra');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-24 pb-12 px-4 md:pt-32 md:pb-16 text-center" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <h1 className="text-3xl md:text-5xl font-bold text-[#3C1518] mb-8 leading-tight" data-id="element-69">
          Cansado de seguir recetas de tortas que no funcionan.
        </h1>

        <div className="relative max-w-lg mx-auto mb-10" data-id="element-70">
          <div className="absolute inset-0 bg-[#EA580C]/15 blur-3xl rounded-full" data-id="element-71" />
          <img src="https://cdn.magicpatterns.com/uploads/pjNYPMa38ZXenkpPoKnA5F/0_cover_1.png" alt="Tortas Caseras Que Siempre Salen Bien" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-72" />
        </div>

        <button onClick={scrollToCompra} className="w-full md:w-auto py-4 px-8 bg-[#EA580C] hover:bg-[#C2410C] text-white text-xl font-bold rounded-xl transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(234,88,12,0.2)]" data-id="element-73">
          ¡QUIERO MI RECETARIO AHORA!
        </button>
      </div>
    </section>;
}